import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { OperatorAuthProvider } from './context/OperatorAuthProvider'
import { ErrorBoundary } from './components/ErrorBoundary'
import Layout from './components/Layout'
import EnhancedDashboard from './pages/EnhancedDashboard'
import SystemMonitoring from './pages/SystemMonitoring'
import UserManagement from './pages/UserManagement'
import OperatorSignIn from './pages/OperatorSignIn'
import OperatorSecurity from './pages/OperatorSecurity'
import TenantAccounts from './pages/TenantAccounts'
import AuthMigration from './pages/AuthMigration'
import ReportsAnalytics from './pages/ReportsAnalytics'
import DatabaseTools from './pages/DatabaseTools'
import Companies from './pages/Companies'
import FeatureFlags from './pages/FeatureFlags'
import Plans from './pages/Plans'
import NewsLibrary from './pages/news/NewsLibrary'
import NewsCompose from './pages/news/NewsCompose'
import Settings from './pages/Settings'
import CustomAccountSettings from './pages/CustomAccountSettings'
import AppVersionControl from './pages/AppVersionControl'
import StorageConfiguration from './pages/StorageConfiguration'
import QuickBooksManagement from './pages/QuickBooksManagement'
import SignupsTrials from './pages/signups/SignupsTrials'
import ServerLogs from './pages/ServerLogs'
import TenantDataExport from './pages/TenantDataExport'
import EmailTemplates from './pages/EmailTemplates'
import EmailNotificationTest from './pages/EmailNotificationTest'
import BrandingSettings from './pages/BrandingSettings'
import AuditLogs from './pages/AuditLogs'
import ErrorReports from './pages/ErrorReports'
import Maintenance from './pages/Maintenance'
import RequireAuth from './components/RequireAuth'
import AuthCallback from './components/AuthCallback'
import AuthLogout from './components/AuthLogout'

function AuthenticatedLayout() {
  return (
    <RequireAuth>
      <Layout>
        <Outlet />
      </Layout>
    </RequireAuth>
  )
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/logout" element={<AuthLogout />} />
      <Route path="/signin" element={<OperatorSignIn />} />
      <Route path="/security/setup" element={<RequireAuth><OperatorSecurity /></RequireAuth>} />
      <Route path="/login" element={<Navigate to="/signin" replace />} />

      <Route element={<AuthenticatedLayout />}>
        <Route path="/" element={<EnhancedDashboard />} />
        <Route path="/monitoring" element={<SystemMonitoring />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/tenant-accounts" element={<TenantAccounts />} />
        <Route path="/auth-migration" element={<AuthMigration />} />
        <Route path="/reports" element={<ReportsAnalytics />} />
        <Route path="/database" element={<DatabaseTools />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/features" element={<FeatureFlags />} />
        <Route path="/plans" element={<Plans />} />
        {/* News (was Announcements): the library and the composer. /announcements
            stays the canonical path so old links and bookmarks keep working. */}
        <Route path="/announcements" element={<NewsLibrary />} />
        <Route path="/announcements/new" element={<NewsCompose />} />
        <Route path="/announcements/:id" element={<NewsCompose />} />
        <Route path="/news" element={<Navigate to="/announcements" replace />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/account-settings" element={<CustomAccountSettings />} />
        <Route path="/app-versions" element={<AppVersionControl />} />
        <Route path="/storage-config" element={<StorageConfiguration />} />
        <Route path="/quickbooks" element={<QuickBooksManagement />} />
        <Route path="/signups" element={<SignupsTrials />} />
        {/* Trial Management became Signups & trials; keep old links working. */}
        <Route path="/trials" element={<Navigate to="/signups?tab=trials" replace />} />
        <Route path="/server-logs" element={<ServerLogs />} />
        <Route path="/data-export" element={<TenantDataExport />} />
        <Route path="/schema-templates" element={<Navigate to="/database?tab=schema" replace />} />
        <Route path="/email-templates" element={<EmailTemplates />} />
        <Route path="/email-notification-test" element={<EmailNotificationTest />} />
        <Route path="/branding" element={<BrandingSettings />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
        <Route path="/error-reports" element={<ErrorReports />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/backups" element={<Navigate to="/database?tab=backups" replace />} />
        <Route path="/data-retention" element={<Navigate to="/database?tab=retention" replace />} />
      </Route>
    </Routes>
  )
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <OperatorAuthProvider>
          <AppRoutes />
        </OperatorAuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default App
